/**
 * Дефолтні налаштування додатку (fallback якщо localStorage порожній)
 */
export const defaultSettings = {
  application_lang: 'en',
  application_version: 'v1',
  application_theme: 'light',
} as const

export type AppSettings = {
  application_lang: string
  application_version: string
  application_theme: string
}
